export default [
    {
        path: 'relatorio-inconsistencia',
        component: () => import(/* webpackChunkName: 'bpa-relatorio-inconsistencia' */ '@/views/bpa/relatorio-inconsistencia/Index'),
        redirect: 'relatorio-inconsistencia/index',
        children: [
            {
                name: 'bpa-relatorio-inconsistencia-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'bpa-relatorio-inconsistencia' */ '@/views/bpa/relatorio-inconsistencia/List.vue'),
            },
        ],
    },
]